module.exports = __webpack_public_path__ + "static/img/background.5c8d04cd.png";